import { useContext } from 'react';
import { SecurityContext } from './SecurityContext';

export const useSecurityContext = () => {
  return useContext(SecurityContext);
};

export default useSecurityContext;